import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';

import DateTime from 'common/components/DateTime/DateTime';
import StandardRichTextEditor from 'common/components/RichTextEditor/StandardRichTextEditor';
import FilePreview from 'common/components/FilePreview/FilePreview';
import WorkflowDocumentViewer from 'workflow/containers/WorkflowDocumentViewer';
import { UserHasEmailRemindersFeatureAccess } from 'common/features';

import {
    Container,
    FormSection,
    DocumentSection,
    ActionButton,
    parseAndEscapeDescription
} from 'forms/components/common';


class SdfaInboxItem extends Component {
    render() {
        const {
            inboxItem: {
                title,
                dueDate,
                reminderDate,
                description,
                actionName,
                finished,
                deleted,
                status
            },
            taskId,
            document,
            actionText,
            onActionClicked
        } = this.props;

        const isActionable = !finished && !deleted;
        const ReminderDateField = UserHasEmailRemindersFeatureAccess(ReminderDateFormSection);
        const { descriptionData, hasDescription } = parseAndEscapeDescription(description);

        return (
            <Container data-cy="UsersSelector-SdfaInboxItem">
                <FormSection headerText="Title" data-cy="UsersSelector-title">
                    { title }
                </FormSection>

                <FormSection headerText="Due Date" data-cy="UsersSelector-Due">
                    <DateTime value={dueDate} time={false} format={'DD MMM YYYY'}/>
                </FormSection>

                <ReminderDateField reminderDate={reminderDate} data-cy="UsersSelector-reminderDate"/>

                { !isActionable && (
                    <FormSection headerText="Status" data-cy="UsersSelector-Status">
                        {lodash.startCase(status)}
                    </FormSection>
                )
                }

                <FormSection headerText="Requested Action" data-cy="UsersSelector-Requested">
                    { lodash.startCase(actionName) }
                </FormSection>

                { hasDescription && (
                    <FormSection headerText="Description" data-cy="UsersSelector-Description">
                        <StandardRichTextEditor
                            readOnly={true}
                            content={descriptionData} />
                    </FormSection>
                ) }

                <FormSection headerText="Document Requesting Action" data-cy="UsersSelector-Document">
                    <FilePreview
                        document={document}
                        viewDocumentPermission = {true} //assignee always have access to view document
                        onClick={this.props.viewDocument}/>

                </FormSection>

                { isActionable && (
                    <DocumentSection headerText="Document Preview" data-cy="UsersSelector-Preview">
                        <WorkflowDocumentViewer noScroll={true} noHeader={true} taskId={taskId}/>
                    </DocumentSection>
                )
                }

                { isActionable && (
                    <ActionButton
                        actionText={actionText}
                        onActionClick={onActionClicked} 
                        data-cy="UsersSelector-Btn"/>
                )
                }
            </Container>
        );
    }
}

const ReminderDateFormSection = ({ reminderDate }) => (
    <FormSection headerText="Reminder Date" data-cy="UsersSelector-Reminder">
        <DateTime value={reminderDate} time={false} />
    </FormSection>
);

SdfaInboxItem.propTypes = {
    inboxItem: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        dueDate: PropTypes.string.isRequired,
        reminderDate: PropTypes.string.isRequired,
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        actionName: PropTypes.string.isRequired,
    }).isRequired,
    taskId: PropTypes.string,
    document: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        uploadedBy: PropTypes.shape({
            displayName: PropTypes.string.isRequired,
            emailAddress: PropTypes.string.isRequired
        }),
        uploadDate: PropTypes.string.isRequired
    }),
    actionText: PropTypes.string,
    onActionClicked: PropTypes.func
};

export default SdfaInboxItem;
